import React from 'react';
import { CourseOptionFilter } from '../../../types';
import { CourseOptionFilterType } from '../../../constants';
import { useDropdownMenu } from '../../../hooks';
import {
  StyledTableInteractiveHeader,
  StyledTableMenuPosition,
  Icon,
  FlexEnd,
} from '../../../styledComponents';
import { Menu } from '../../../dataComponents';
import { TableHeaderProps } from '../TableHeader';

export type TableInteractiveHeaderProps = {
  filterKey: CourseOptionFilterType;
  options: CourseOptionFilter[];
  alignRight?: boolean;
} & TableHeaderProps;

export const TableInteractiveHeader = ({
  filterKey,
  options,
  icon,
  label,
  alignRight,
}: TableInteractiveHeaderProps) => {
  const { ref, open, handleToggle, handleClose } = useDropdownMenu();

  const Wrapper = alignRight ? FlexEnd : 'div';

  return (
    <Wrapper ref={ref}>
      <StyledTableInteractiveHeader onClick={handleToggle}>
        {icon}
        <p>{label}</p>
        <Icon matIcon={open ? 'expand_less' : 'expand_more'} />
      </StyledTableInteractiveHeader>
      <StyledTableMenuPosition>
        <Menu
          open={open}
          filterKey={filterKey}
          items={options}
          onClose={handleClose}
        />
      </StyledTableMenuPosition>
    </Wrapper>
  );
};
